import axiosInstance from './axiosConfig';
import { setLocalStorageIfExists } from '../utils/setLocalStorageIfExists';

// Get User Profile ata
export const getUserProfile = async (data) => {
  const response = await axiosInstance.get('/profile');
  if(response?.data?.success === true || response?.data?.success === "true"){
    setLocalStorageIfExists('email', response?.data?.data?.email);
    setLocalStorageIfExists('first_name', response?.data?.data?.first_name);
    setLocalStorageIfExists('last_name', response?.data?.data?.last_name);
    setLocalStorageIfExists('block-user', response?.data?.data?.is_blocked);
  }
  return response.data;
};

export const addAddressProfile = async (data)=>{
  const response = await axiosInstance.post('/profile',data);
  return response.data;
}

export const fetchStateProfile = async (pincode)=>{
  const response = await axiosInstance.get(`/profile/pincode_lookup?pincode=${pincode}`);
  return response.data;
}

// Update User Profile Data
export const updateUserProfile = async (data) => {
  const response = await axiosInstance.patch('/profile', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  if (response?.data?.success === true || response?.data?.success === "true") {
    setLocalStorageIfExists('email', response?.data?.data?.email);
    setLocalStorageIfExists('first_name', response?.data?.data?.first_name);
    setLocalStorageIfExists('last_name', response?.data?.data?.last_name);
    setLocalStorageIfExists('block-user', response?.data?.data?.is_blocked);
  }

  return response.data;
};
